import { render } from "./AppToggle.vue?vue&type=template&id=25b3bac3"
import script from "./AppToggle.vue?vue&type=script&lang=js"
export * from "./AppToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__